import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";

declare var ko: any;

export class ideationTopicList_template extends vnTemplate {


    protected filter: filterSimple_template;
    protected dateFilter: filterDate_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected seedFilter: filterAutocomplete_template;
    protected sourceFilter: filterAutocomplete_template;

    protected getTemplateHtml(): string {
        return /*html*/`
                <div class="page-tabs">
                    <button type="button" title="Edit My Sources" class="page-tab-menu icon i-menu-pwa" data-bind="click: onClickEditSources"></button>
                    <ul data-bind="foreach: $data.sources">
                        <li><a href="#" data-bind="text: $data.name.toUpperCase(), click: $parent.onClickSource, css: {'is-selected' : $data.id == $parent.idSelectedSource()}"></a></li>
                    </ul>
                </div>

                <div class="new-list-header w-justify">
                    <div class="w-left">
                        ${ this.dateFilter.getHtmlBuild() }
                        <!-- ko if: idSelectedSource() == 1 -->
                        ${ this.seedFilter.getHtmlBuild() }
                        <!-- /ko -->
                        <!-- ko if: idSelectedSource() == 3 -->
                        ${ this.sourceFilter.getHtmlBuild() }
                        <!-- /ko -->
                        <button type="button" id="generate-btn" title="Generate Topics" class="page-tab-menu icon" data-bind="visible: isShowGenerateButton(), click: onClickGenerateTopics">Generate</button>
                    </div>
                    <div class="w-center">
                        ${this.filter.getHtmlBuild()}
                    </div>
                    <div class="w-right">
                         ${this.pagination.getHtmlBuild()}
                    </div>
                </div>

                <div class="w-new-list-results" id="list-results" name="list-results">

                    <table class="new-list-results">
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'category') }, css: { 'list-sort-desc': orderByAndDirection()=='category_DESC', 'list-sort-asc': orderByAndDirection()=='category_ASC' }">Seed</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Topic</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'angles') }, css: { 'list-sort-desc': orderByAndDirection()=='angles_DESC', 'list-sort-asc': orderByAndDirection()=='angles_ASC' }">Angles</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'trendingReason') }, css: { 'list-sort-desc': orderByAndDirection()=='trendingReason_DESC', 'list-sort-asc': orderByAndDirection()=='trendingReason_ASC' }">Trending Reason</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'keyPoints') }, css: { 'list-sort-desc': orderByAndDirection()=='keyPoints_DESC', 'list-sort-asc': orderByAndDirection()=='keyPoints_ASC' }">Key Points</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Generation Date</span></th>
                                <th><span>Delete</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: topics">
                            <tr class="cursor" data-bind="css: $data.categoryClass">
                                <td>
                                    <span class="cat" data-bind="html: $data.category"></span>
                                    <button class="icon i-copy" title="Copy to clipboard" data-bind="event:{ click: $parent.onClickCopyToClipboard.bind($data, 'category')}"></button>
                                </td>
                                <td>
                                    <span data-bind="text: $data.name"></span>
                                     <!-- ko if: $data.ctrScore != null -->
                                    <span class="ctr" data-bind="css: $data.ctrClass, visible: false">
                                        <span class="ctr-value" data-bind="text: $data.ctrScore  + '%'"></span>
                                        <!-- ko if: $data.ctrTooltip && $data.ctrTooltip != null -->
                                        <div class="tooltip" data-bind="html: $data.ctrTooltip"></div>
                                        <!-- /ko -->
                                    </span>
                                    <!-- /ko -->
                                    <button class="icon i-copy" title="Copy to clipboard" data-bind="event:{ click: $parent.onClickCopyToClipboard.bind($data, 'name')}"></button>
                                </td>
                                <td>
                                    <ul class="list-hor" data-bind="foreach: $data.angles">
                                        <li>
                                            <strong data-bind="text: $data.title"></strong>
                                            <div class="expand-control-container">
                                                <label class="toggle-label-wrapper">
                                                    <input type="checkbox" class="toggle-checkbox">

                                                    <span class="toggle-button icon i-dropdown-simple-b"></span>

                                                    <span class="expandable-content" data-bind="text: $data.excerpt"></span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                    <button class="icon i-copy" title="Copy to clipboard" data-bind="event:{ click: $parent.onClickCopyToClipboard.bind($data, 'angles')}"></button>
                                </td>
                                <td>
                                    <span data-bind="html: $data.trendingReason"></span>
                                    <button class="icon i-copy" title="Copy to clipboard" data-bind="event:{ click: $parent.onClickCopyToClipboard.bind($data, 'trendingReason')}"></button>
                                </td>
                                <td>
                                    <ul data-bind="foreach: $data.keyPoints">
                                        <li><span data-bind="html: $data"></span></li>
                                    </ul>
                                    <button class="icon i-copy" title="Copy to clipboard" data-bind="event:{ click: $parent.onClickCopyToClipboard.bind($data, 'keyPoints')}"></button>
                                </td>
                                <td><span data-bind="text: $data.dateCreated"></span></td>
                                <td class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowDeletePopUp }, clickBubble: false" class="btn border only-icon icon i-delete"></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div id="delete-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Deleting seed</h3>
                                <button type="button"  data-bind="event: { click: onClickHideDeletePopUp }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">This action is irreversible</p>
                                    <p class="form-text">Are you sure you want to delete this topic :

                                        <p data-bind=" if: idTopicToDelete() !== null ">
                                        <span data-bind="text: idTopicToDelete().name"></span>
                                        </p>

                                    </p>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickHideDeletePopUp }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                            </div>
                        </div>

                    </div>
                </div>
         `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        let currentDate = new Date();
        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setDateRange(
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0),
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59),
        );
        this.dateFilter.toggleClearButton(false);
        this.dateFilter.setLabel('Date Range');

        let brandId = this.caller.getIdBrand();
        if (brandId == 6) {
            this.getTemplateViewModel().showParentName(true);
        }

        this.seedFilter = new filterAutocomplete_template("seedFilter", this.getTemplateViewModel(), this.caller);
        //this.seedFilter.setAddNewOptionEnabled(true);
        this.seedFilter.setIsShowCurrentSelection(false);
        this.seedFilter.setNumberOfChars(2);
        this.seedFilter.setPlaceholder("Seed");
        this.seedFilter.setOptionType("Seed");

        this.sourceFilter = new filterAutocomplete_template("sourceFilter", this.getTemplateViewModel(), this.caller);
        this.sourceFilter.setAddNewOptionEnabled(true);
        this.sourceFilter.setIsShowCurrentSelection(false);
        this.sourceFilter.setNumberOfChars(2);
        this.sourceFilter.setPlaceholder("Source");
        this.sourceFilter.setOptionType("Source");

    }

    protected getTemplateName(): string {
        return "ideationTopicList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["new-style"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            topics: ko.observableArray([]),
            sources: ko.observableArray([]),
            idSelectedSource: ko.observable(null),
            selectedSource: ko.observable(null),
            selectedSeed: ko.observable(null),
            orderBy: ko.observable("dateCreated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            isVisible: ko.observable(false),
            isShowGenerateButton: ko.observable(false),
            showParentName: ko.observable(false),
            popupAction: ko.observable("add"),
            idTopicToDelete: ko.observable(null),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickCancel: function (value, data, event) {
                self.onClickCancel()
            },
            onClickSave: function (value, data, event) {
                self.onClickSave()
            },
            onClickSource: function (value, data, event) {
                self.onClickSource(value)
            },
            onClickEditSources: function (value, data, event) {
                self.onClickEditSources()
            },
            onClickGenerateTopics: function (value, data, event) {
                self.onClickGenerateTopics()
            },
            onClickShowDeletePopUp: function (value, data, event) {
                self.onClickShowDeletePopUp(value)
            },
            onClickHideDeletePopUp: function (value, data, event) {
                self.onClickHideDeletePopUp()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            },
            onClickCopyToClipboard: function (value, data, event) {
                self.onClickCopyToClipboard(value, data)
            },
        }
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }


    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                idSource: this.getTemplateViewModel().idSelectedSource(),
                seed: this.getTemplateViewModel().seedFilter.optionObj(),
                source: this.getTemplateViewModel().sourceFilter.optionObj()
            }
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);

        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.topicsListReorder();
    }

    public setTopics(topics) {

        this.getTemplateViewModel().topics(topics);
    }

    public setSeedFilterOptions(seeds) {

        this.seedFilter.setOptions(seeds);
    }

    public setSeedFilterText(inputText) {

        this.seedFilter.setInputText(inputText);
    }

    public getSeedFilterSelectionName() {

        let seedFilterSelection = this.seedFilter.getOptionObj();

        if(seedFilterSelection && seedFilterSelection.name){
            return seedFilterSelection.name;
        }

        return "";
    }

    public getSeedFilterSelection() {

        return this.seedFilter.getOptionObj();
    }

    public getSourceFilterSelection() {

        return this.sourceFilter.getOptionObj();
    }

    public setSourceFilterOptions(seeds) {

        this.sourceFilter.setOptions(seeds);
    }

    public setSourceFilterOption(source) {

        this.sourceFilter.setOption(source);
    }

    public setSourceFilterText(inputText) {

        this.sourceFilter.setInputText(inputText);
    }

    public getSourceFilterSelectionName() {

        let sourceFilterSelection = this.sourceFilter.getOptionObj();

        if(sourceFilterSelection && sourceFilterSelection.name){
            return sourceFilterSelection.name;
        }

        return "";
    }

    public setSources(sources) {

        this.getTemplateViewModel().sources(sources);
    }

    public setIdSelectedSource(idSource) {

        this.getTemplateViewModel().idSelectedSource(idSource);
    }

    public getSelectedSource() {

        return this.getTemplateViewModel().selectedSource();
    }

    public toggleAddNew(){
        this.sourceFilter.setNewOptionName("");
        this.sourceFilter.toggleAddNew();
    }

    public setSelectedSource(source) {

        if(source != null){
            this.sourceFilter.setAddNewOptionEnabled(false);
        }else{
            this.sourceFilter.setAddNewOptionEnabled(true);
        }

        this.getTemplateViewModel().selectedSource(source);
    }

    public setSelectedSeed(seed) {

        this.getTemplateViewModel().selectedSeed(seed);
    }

    public toggleShowGenerateButton(){

        let isShowGenerateButton = this.getTemplateViewModel().isShowGenerateButton();

        this.setIsShowGenerateButton(!isShowGenerateButton);
    }

     public setIsShowGenerateButton(show){

        this.getTemplateViewModel().isShowGenerateButton(show);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickShowPopUp(action) {
        if (action === 'add') {
            this.getTemplateViewModel().selectedSegment({
                id: null,
                name: '',
                parentName: '',
                activeStatus: 0,
                dateCreated: null,
                dateUpdated: null
            });
        }

        this.getTemplateViewModel().popupAction(action);
        this.getTemplateViewModel().isVisible(true);
    }

    public onClickCancel() {
        this.getTemplateViewModel().isVisible(false);
    }

    public onClickSave() {

        this.getTemplateViewModel().isVisible(false);
        this.caller.saveSegment(this.getTemplateViewModel().selectedSegment());
    }

     public onClickSource(data) {

        this.getTemplateViewModel().idSelectedSource(data.id);
        this.getTemplateViewModel().selectedSource(null);
        this.getTemplateViewModel().selectedSeed(null);
        this.seedFilter.clearInputNoCallback();
        this.sourceFilter.clearInputNoCallback();
        this.caller.filterList();
    }

    public onClickEditSources() {

        this.caller.editSources();
    }

    public onClickGenerateTopics() {

        //if(confirm("Are you sure you want to generate topics for this source? This will overwrite existing topics for today.")) {

        document.getElementById("generate-btn").setAttribute("disabled", "true");
        document.getElementById("generate-btn").innerText = "Generating...";
        let selectedSource = this.getTemplateViewModel().selectedSource();
        if(selectedSource && selectedSource.id){
            this.caller.generateTopics(selectedSource.id);
        }else{

            let addNewSource = this.sourceFilter.getNewOptionName();

            if(addNewSource && addNewSource != ""){
                this.caller.generateTopics(null, addNewSource)
            }
        }



        //}

    }

    public onClickHideDeletePopUp(): any {
        this.getTemplateViewModel().idTopicToDelete(null);
        this.toggleDeleteDialogVisibility()
    }

    public onClickShowDeletePopUp(data): any {

        this.getTemplateViewModel().idTopicToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public onClickDelete() {
        let topic_id = this.getTemplateViewModel().idTopicToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteTopic(topic_id);
    }

    public onClickCopyToClipboard(value, data) {

        let textToCopy = data[value];

        if(value == "trendingReason"){
            textToCopy = data["originalTrendingReason"];
        }

        if(value == "category"){
            textToCopy = data["originalCategory"];
        }

        if(value == "angles"){
            textToCopy = data[value].map(item =>
            `• ${item.title}\n   ◦ ${item.excerpt}`
            ).join('\n\n');
        }

        if(value == "keyPoints"){
            textToCopy = data["originalKeyPoints"].map(item =>
            `• ${item}`
            ).join('\n\n');
        }

        window.navigator['clipboard'].writeText(textToCopy);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/ideationTopicList_template.ts